import React from "react";
import MyAbout from "./MyAbout";

const About = () => {
  return <>
   <MyAbout />   

  </>;
};

export default About;
